import { cx } from '@linaria/core';
import { useId } from 'react';
import { NotificationCount } from '@pm2/react-utils';
import { breakpoints } from '@ui/css';
import { Tablist, Search } from '@ui/kit';
import { ShowFor, HideFor } from '@utils/react';
import { MobileSearch } from '../../../atoms/search.mobile.js';
import { isNotificationConsideredRecent } from '../../notifications/util.is-considered-recent.js';
import { heading, header } from '../../shared.header.style.js';
import { useCoursesWithNotifications } from '../hook.courses-with-notifications.js';
import { filterCourses, CourseSections } from '../hooks/filtered-courses.js';
import { tabListTitle, tabToggleNotificationBadge, headerCls, tablistWrapperCls, tabsCls, searchCls } from './topbar.teacher.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function TeacherTopbar({
  courses,
  filterOptions,
  filterCallbacks
}) {
  const baseId = `teacher-tablist-${useId()}`;
  const sharedCoursesCount = filterCourses(courses, {
    ...filterOptions,
    section: CourseSections.SHARED
  }).length;
  const coursesWithNotifications = useCoursesWithNotifications();
  const notificationCount = coursesWithNotifications.data?.filter(it => isNotificationConsideredRecent(it.shareNotification)).length;
  const tabs = (() => {
    const rawTabs = [{
      id: CourseSections.MY_COURSES,
      title: /*#__PURE__*/jsx("div", {
        className: tabListTitle,
        children: /*#__PURE__*/jsx("span", {
          children: "Mine forl\xF8b"
        })
      })
    }];
    if (sharedCoursesCount > 0) {
      rawTabs.push({
        id: CourseSections.SHARED,
        title: /*#__PURE__*/jsxs("div", {
          className: tabListTitle,
          children: [/*#__PURE__*/jsx(ShowFor, {
            breakpoint: breakpoints.tablet.andDown(),
            children: "Delt med mig"
          }), /*#__PURE__*/jsx(HideFor, {
            breakpoint: breakpoints.tablet.andDown(),
            children: "Forl\xF8b delt med mig"
          }), /*#__PURE__*/jsx(NotificationCount, {
            className: tabToggleNotificationBadge,
            count: notificationCount,
            active: !!notificationCount
          })]
        })
      });
    }
    return rawTabs;
  })();
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("header", {
      className: cx(header, headerCls),
      children: [/*#__PURE__*/jsx("h1", {
        className: heading,
        children: "Mine forl\xF8b"
      }), /*#__PURE__*/jsx(ShowFor, {
        breakpoint: breakpoints.mobile,
        children: /*#__PURE__*/jsx(MobileSearch, {
          label: "S\xF8g i forl\xF8b",
          onQueryChange: filterCallbacks.onQueryChange
        })
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: tablistWrapperCls,
      children: [/*#__PURE__*/jsx(Tablist, {
        className: tabsCls,
        baseId: baseId,
        label: "V\xE6lg sektion",
        tabs: tabs,
        selectedTabId: filterOptions.section,
        onTabClick: filterCallbacks.onSectionChange
      }), /*#__PURE__*/jsx(HideFor, {
        className: searchCls,
        breakpoint: breakpoints.mobile.andDown(),
        children: /*#__PURE__*/jsx(Search, {
          theme: "local",
          debounceMs: 350,
          compact: true,
          placeholder: "S\xF8g i forl\xF8b",
          "aria-label": "S\xF8g i forl\xF8b",
          onQueryChange: filterCallbacks.onQueryChange
        })
      })]
    })]
  });
}

export { TeacherTopbar };
//# sourceMappingURL=topbar.teacher.js.map
